<template>
  <div>
    <div class="mb-10">

      <div v-show="!loading">
        <router-link :to="{ name: 'auth.login' }">
          <small class="muted--text">Back to Login</small>
        </router-link>
      </div>

      <h1 title="Login" class="mb-5">
        Email Verification
      </h1>

      <div v-show="loading">
        <h3 style="font-weight: normal !important;">Please wait...</h3>
      </div>

      <v-alert v-if="undefined != err.message" type="error" class="mb-8" outlined dense>
        {{ err.message }}
      </v-alert>

      <v-alert v-if="isShowSuccess" type="success" class="mb-8" outlined dense>
        {{ message }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isShowSuccess: false,
      loading: true,
      message: ''
    };
  },
  computed: {
    ...mapGetters({
      err: "auth/GET_ERR",
    }),
  },
  methods: {
    ...mapActions({
      actionVerifyEmail: "auth/actionVerifyEmail",
    }),

    generateCsrfToken() {
      let apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

      axios({
        method: 'GET',
        baseURL: 'https://apidealerportal.hondaphil.com/',
        url: 'sanctum/csrf-cookie',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        withCredentials: true
      })
        .then(() => { })
        .catch(error => {
          console.error(error.response.message)
        })
    },

    async verifyEmail() {

      await this.generateCsrfToken();

      let response = await this.actionVerifyEmail({
        id: this.$route.params.userId,
        email: this.$route.query.email,
        expiry: this.$route.query.expiry
      });

      this.loading = false;

      if (response.success) {
        this.message = response.message || 'Email successfully verified.'
      }
      if (this.err.message == undefined) {
        this.isShowSuccess = true;
      }
    },
  },
  created() {
    this.verifyEmail();
  }
};
</script>

<style></style>